import { render, staticRenderFns } from "./ScoreModule.vue?vue&type=template&id=74d0bbfa&scoped=true&"
import script from "./ScoreModule.vue?vue&type=script&lang=js&"
export * from "./ScoreModule.vue?vue&type=script&lang=js&"
import style0 from "./ScoreModule.vue?vue&type=style&index=0&id=74d0bbfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d0bbfa",
  null
  
)

export default component.exports